<script setup>
import { Head, Link, usePage } from "@inertiajs/vue3";
import VDevider from "@/Shared/VDevider.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import {
    listTabDepartingVisitor,
    listTabSabahOutbound,
} from "../PublicPage/Survey/tabs.config";

const props = defineProps({
    title: String,
    additional: Object,
});

const { questionnaire, urlDetailTemplate, urlIndex } = props.additional;

const TYPE_SURVEY_DEPARTING = "departing-visitor-survey";
const TYPE_SURVEY_OUTBOUND = "sabah-outbound-survey";

const tabs =
    questionnaire.code == TYPE_SURVEY_DEPARTING
        ? listTabDepartingVisitor
        : listTabSabahOutbound;

const breadcrumbs = [
    {
        url: urlIndex,
        label: "Questionnaire",
    },
    {
        url: "#",
        label: questionnaire.name,
    },
];

const appBaseUrl = usePage().props.appBaseUrl;
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="additional.urlIndex"
                        :filters="additional.filters ?? {}"
                    >
                        Questionnaire {{ questionnaire.name }}
                    </VTitleWithBackLink>
                </div>

                <VDevider />
                <div class="row align-items-center mt-3 mb-4 text-center">
                    <div
                        v-for="(tab, index) in tabs"
                        class="col-6 col-md-4 col-lg-3 p-2 p-md-4 p-lg-4 d-flex"
                    >
                        <Link
                            :href="
                                urlDetailTemplate.replace('tab_code', tab.key)
                            "
                            class="box-button p-2 p-md-3"
                        >
                            {{ tab.title }}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.box-button {
    width: 100%;
    max-width: 200px;
    aspect-ratio: 1 / 1;
    border-radius: 30px;
    background-color: #67b196;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    line-height: 1.25rem;
    font-size: 1rem;
    font-weight: 500;
}

.box-button:hover {
    background-color: #4d977c;
}
</style>
